/*
 * Module for the Demographics Person view
 */
rs.module("content/participant/about/demographics/person",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        var _disabilityCheckbox;
        var _disabilityCertFiled;
        var _disabilityTypeHelper;

        var _studentCheckbox;
        var _studentCertFiled;

        function initialize(jsSelectors, cssSelectors) {

            var demographicsForm = $.js(jsSelectors.demographicsForm);

            // initialize module-scoped variables
            _disabilityCheckbox = demographicsForm.js(jsSelectors.disabilityCheckbox);

            var disabilityType = demographicsForm.js(jsSelectors.disabilityTypeDropdown);
            _disabilityTypeHelper = selectHelper.getHelper(disabilityType);

            _disabilityCertFiled = demographicsForm.js(jsSelectors.disabilityCertFiledDatePicker);

            _studentCheckbox = demographicsForm.js(jsSelectors.studentCheckbox);
            _studentCertFiled = demographicsForm.js(jsSelectors.studentCertFiledDatePicker);

            var historyContainer = demographicsForm.js(jsSelectors.historyContainer);
            var historyPanel = demographicsForm.js(jsSelectors.historyPanel);

            // show/hide name/ssn history on hover with intent
            // TODO: leverage visibility module for this, once hover popups are normalized
            historyContainer.hoverIntent({
                handlerOver: function (event) {
                    historyPanel.toggleClass(cssSelectors.visible, true);
                },
                handlerOut: function (event) {
                    historyPanel.toggleClass(cssSelectors.visible, false);
                },
                hoverOutDelay: 400
            });

            // run disabilityChanged() and studentChanged() on ready so page behaves correctly on initialize
            $(disabilityChanged);
            $(studentChanged);

            // register checkbox change events
            _disabilityCheckbox.change(disabilityChanged);
            _studentCheckbox.change(studentChanged);
        }

        // disable and clear the disability fields when Disability unchecked
        function disabilityChanged() {
            if (_disabilityCheckbox.is(":checked")) {
                _disabilityTypeHelper.setDisabled(false);
                _disabilityCertFiled.prop("disabled", false);
            }
            else {
                _disabilityTypeHelper.setDisabled(true).setValue("");
                _disabilityCertFiled.val("").prop("disabled", true);
            }
        }

        // disable and clear the cert filed date field when Full Time Student unchecked
        function studentChanged() {
            if (_studentCheckbox.is(":checked")) {
                _studentCertFiled.prop("disabled", false);
            }
            else {
                _studentCertFiled.val("").prop("disabled", true);
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);